import type { ContextMenuItem } from '../../components/ContextMenu';
import type { CanvasLayer } from '../types';

export function buildLayerSubmenuItems(
  layers: CanvasLayer[],
  currentLayerId: string,
  onSetLayer: (layerId: string) => void,
): ContextMenuItem[] {
  const effectiveCurrentId = currentLayerId;
  return layers.map(layer => ({
    id: `layer-${layer.id}`,
    label: `${layer.id === effectiveCurrentId ? '● ' : ''}${layer.name}`,
    onClick: () => onSetLayer(layer.id),
  }));
}
